module.exports = __webpack_public_path__ + "img/trial.8011e390.png";